import {CancellationPenalties} from '@findhotel/sapi'
import {subHours} from 'date-fns/subHours'

import {getPersistedConfiguration} from '../services/offerConfigurationApi/store'
import {CancellationPenalty} from '../types/offer'
import {getCancellationDeadline} from './cancellationPenalties'

/**
 * Calculates the charge date based on the cancellation penalties.
 * @param cancellationPenalties - Array of CancellationPenalty or CancellationPenalties objects.
 * @returns The calculated charge date as a Date object.
 */
export const calculateChargeDate = (
  cancellationPenalties: CancellationPenalty[] | CancellationPenalties[]
) => {
  const configuration = getPersistedConfiguration()
  const chargeLaterConfiguration = configuration.chargeLater
  const {autoChargeLeadHours} = chargeLaterConfiguration || {}

  if (!autoChargeLeadHours) return undefined

  const cancellationDeadline = getCancellationDeadline(cancellationPenalties)
  const cancellationDeadlineDate =
    cancellationDeadline && new Date(cancellationDeadline)
  return cancellationDeadlineDate
    ? subHours(cancellationDeadlineDate, autoChargeLeadHours)
    : undefined
}
